import type { ReactNode } from "react"

/**
 * The four gold corner flourishes on their own. Drop these inside any element
 * that carries the `framed` class (which makes it the positioning context); use
 * this form when the element is already a styled container, so no extra wrapper
 * div disturbs its layout. The art (frame_corner.png) is a single top-left
 * corner; the spans rotate it 0/90/180/270° into place. Purely decorative.
 */
export function FrameCorners() {
  return (
    <>
      <span className="framed-corner framed-corner-tl" aria-hidden="true" />
      <span className="framed-corner framed-corner-tr" aria-hidden="true" />
      <span className="framed-corner framed-corner-br" aria-hidden="true" />
      <span className="framed-corner framed-corner-bl" aria-hidden="true" />
    </>
  )
}

/**
 * Wraps content in the four corner flourishes, adding its own `framed` box. Use
 * this when a plain wrapper is fine; for an element that is already a styled
 * container, add the `framed` class to it and drop <FrameCorners/> inside.
 */
export function Framed({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={className ? `framed ${className}` : "framed"}>
      <FrameCorners />
      {children}
    </div>
  )
}
